import Link from 'next/link'
import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { Button, Card, CardContent } from '@material-ui/core'

import ROUTES from '~/constants/routes'

import { Text } from '../../shared'

import { useReferralsCardStyles } from './ReferralsCard.styles'

type ReferralCardProps = {
  title: string
  countReferrals: number
  isClinic?: boolean
  status?: string
}

const scope = 'components.cards.ReferralsCard'

const ReferralsCard: FC<ReferralCardProps> = ({
  title,
  countReferrals,
  isClinic,
  status
}) => {
  const s = useReferralsCardStyles()

  const link = isClinic
    ? ROUTES.clinics
    : `${ROUTES.referrals}?status=${status}`

  return (
    <Card>
      <CardContent className={s.container}>
        <Text color="textPrimary" variant="h5">
          {title}
        </Text>
        <Text className={s.countReferrals}>{countReferrals}</Text>

        <Link href={link} passHref>
          <Button variant="outlined" color="primary">
            <FormattedMessage
              id={`${scope}.viewDetails`}
              defaultMessage="View details"
            />
          </Button>
        </Link>
      </CardContent>
    </Card>
  )
}

export default ReferralsCard
